import React from 'react';
import Icon from '../../../components/AppIcon';

const StarDistributionChart = ({ distribution }) => {
  const maxCount = Math.max(...distribution?.map(d => d?.count));

  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-4 md:p-6">
      <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4 md:mb-6">
        별점 분포
      </h3>
      <div className="space-y-3 md:space-y-4">
        {distribution?.map((item) => {
          const percentage = maxCount > 0 ? (item?.count / maxCount) * 100 : 0;
          
          return (
            <div key={item?.stars} className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <div className="flex items-center">
                    {[...Array(5)]?.map((_, index) => (
                      <Icon
                        key={index}
                        name="Star"
                        size={16}
                        color="currentColor"
                        className={index < item?.stars ? 'fill-current text-primary' : 'text-muted-foreground'}
                      />
                    ))}
                  </div>
                  <span className="text-sm md:text-base text-muted-foreground caption">
                    {item?.stars}점
                  </span>
                </div>
                <span className="text-sm md:text-base font-medium text-foreground data-text">
                  {item?.count?.toLocaleString('ko-KR')}
                </span>
              </div>
              <div className="w-full h-2 md:h-3 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full bg-primary transition-gaming rounded-full"
                  style={{
                    width: `${percentage}%`,
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StarDistributionChart;